import UnAuthenticatedLayout from "@/views/Layouts/UnAuthenticated/UnAuthenticatedLayout.vue";
import BaseLayout from "@/views/Layouts/Authenticated/BaseLayout.vue";

// import modules routes
import defaultModuleRoutes from "./defaultModuleRoutes";
import adminModuleRoutes from "./adminModuleRoutes";
import dashboardModuleRoutes from "./dashboardModuleRoutes";
import resellerModuleRoutes from "./resellerModuleRoutes";
import filesExplorerModuleRoutes from "./filesExplorerModuleRoutes";
import inventoryModuleRoutes from "./inventoryModuleRoutes";
import salesModuleRoutes from "./salesModuleRoutes";
import purchasesModuleRoutes from "./purchasesModuleRoutes";
import crmModuleRoutes from "./crmModuleRoutes";
import auctionModuleRoutes from "./auctionModuleRoutes";
import collectionModuleRoutes from "./collectionModuleRoutes";

//import middleware
import guest from "@/middleware/guest";

// UnAuthenticatedPages
const NotFound = () => import("@/views/Pages/UnAuthenticated/NotFoundPage.vue");
const Login = () => import("@/views/Pages/UnAuthenticated/Login.vue");
const PasswordReset = () =>
  import("@/views/Pages/UnAuthenticated/Password/Reset.vue");
const PasswordEmail = () =>
  import("@/views/Pages/UnAuthenticated/Password/Email.vue");

let unauthenticatedPages = {
  path: "/",
  component: UnAuthenticatedLayout,
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { middleware: guest },
    },
    {
      path: "/password/reset",
      name: "PasswordReset",
      component: PasswordReset,
      meta: { middleware: guest },
    },
    {
      path: "/password/email",
      name: "PasswordEmail",
      component: PasswordEmail,
      meta: { middleware: guest },
    },
  ],
};

const routes = [
  /** base routes */
  {
    path: "/",
    redirect: "/dashboard",
  },
  unauthenticatedPages,
  {
    path: "/not-found",
    component: NotFound,
  },
  {
    path: "/",
    component: BaseLayout,
    children: defaultModuleRoutes,
  },
  {
    path: "/",
    component: BaseLayout,
    children: dashboardModuleRoutes,
  },
  {
    path: "/files",
    component: BaseLayout,
    children: filesExplorerModuleRoutes,
  },
  {
    path: "/inventory",
    component: BaseLayout,
    children: inventoryModuleRoutes,
  },
  {
    path: "/crm",
    component: BaseLayout,
    children: crmModuleRoutes,
  },
  {
    path: "/auctions",
    component: BaseLayout,
    children: auctionModuleRoutes,
  },
  {
    path: "/collections",
    component: BaseLayout,
    children: collectionModuleRoutes,
  },
  {
    path: "/sales",
    component: BaseLayout,
    children: salesModuleRoutes,
  },
  {
    path: "/purchases",
    component: BaseLayout,
    children: purchasesModuleRoutes,
  },
  {
    path: "/reseller",
    component: BaseLayout,
    children: resellerModuleRoutes,
  },
  {
    path: "/admin",
    component: BaseLayout,
    children: adminModuleRoutes,
  },
  {
    path: "**",
    redirect: "/not-found",
  },
];

export default routes;
